import {
  PAGE_EXPERIMENT_NEW_OG_MAPPING,
  PAGE_EXPERIMENT_OPENGATE,
} from "data/experiment"
import { useExperimentContext } from "components/ExperimentProvider"
import { useLocale } from "hooks"
import { usePreRequisteFlagTracking } from "./usePreRequisteFlagTracking"
import { enabledOpengateVariants } from "./productFirst.contants"

export const useUSJourney = (): boolean => {
  const locale = useLocale()
  const { getValue } = useExperimentContext()

  // replace with LD flag
  const isNewMappingEnabled =
    getValue(PAGE_EXPERIMENT_NEW_OG_MAPPING.name) === 1

  const opengateExperimentVariant = getValue(PAGE_EXPERIMENT_OPENGATE.name)

  usePreRequisteFlagTracking()

  const isProductFirstEnabled =
    isNewMappingEnabled &&
    enabledOpengateVariants.includes(Number(opengateExperimentVariant))

  return locale === "en-US" || isProductFirstEnabled
}
